import React from 'react';
import { cx } from './styles';

/**
 * The content column of every app screen.
 *
 * `width="default"` keeps v1's `max-w-6xl` so reading widths and card
 * proportions are unchanged. `width="wide"` is for the three long-list pages
 * (Transfers, Tickets, Listings) that genuinely want the extra room at 1536px+.
 *
 * `grid` opts into the 12-column split, used by exactly two screens
 * (Notifications, Profile). The list-driven pages stay single-column: forcing a
 * 12-col grid onto a stack of full-width rows buys nothing.
 */
export interface PageShellProps {
  width?: 'default' | 'wide' | 'narrow';
  grid?: boolean;
  className?: string;
  children: React.ReactNode;
}

const widthMap = {
  default: 'max-w-6xl',
  wide: 'max-w-6xl 2xl:max-w-[1400px]',
  narrow: 'max-w-lg',
};

export const PageShell: React.FC<PageShellProps> = ({
  width = 'default',
  grid,
  className,
  children,
}) => (
  <div
    className={cx(
      'mx-auto w-full px-4 py-6 pb-20 sm:px-6 lg:px-8 lg:py-10',
      widthMap[width],
      className,
    )}
  >
    {grid ? <div className="xl:grid xl:grid-cols-12 xl:gap-6">{children}</div> : children}
  </div>
);
